import React from "react";
import { Outlet } from "react-router-dom";

/**
 * A component that serves as a layout wrapper for activity-related routes.
 * It uses React Router's Outlet component to render nested routes.
 * 
 * @component
 * @returns {JSX.Element} The rendered activity page layout
 * 
 * @example
 * ```tsx
 * <ActivityPage />
 * ```
 */
const ActivityPage = () => {
  return <Outlet />;
};

export default ActivityPage;
